import { render, staticRenderFns } from "./TableStatic.vue?vue&type=template&id=781cae18&scoped=true"
import script from "./TableStatic.vue?vue&type=script&lang=js"
export * from "./TableStatic.vue?vue&type=script&lang=js"
import style0 from "./TableStatic.vue?vue&type=style&index=0&id=781cae18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781cae18",
  null
  
)

export default component.exports